import { Store } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * In-store "page not found" rendered by the `/s/:slug/*` catch-all. Without it,
 * an unknown store path would fall through to the app's global `*` → /dashboard,
 * which a custom storefront domain's gate would rewrite back under /s/:slug,
 * causing an infinite redirect loop. Resolving within the storefront tree stops
 * that and keeps the store chrome around the message.
 */
export function StorefrontNotFoundPage(): JSX.Element {
  const { t } = useTranslation('cms');
  return (
    <div className="py-20 text-center">
      <Store className="mx-auto h-10 w-10 text-fg-subtle" aria-hidden />
      <h1 className="mt-3 text-xl font-semibold">{t('store.notFound')}</h1>
      <p className="mt-1 text-sm text-fg-muted">{t('store.notFoundHint')}</p>
    </div>
  );
}
